<template>
  <div ref="canvasRef" class="canvas_contents">
    <canvas :id="canvasId"></canvas>
  </div>
</template>
<script>
  import { fabric } from 'fabric'
  export default {
    props: {
      canvasId: {
        type: String,
        default: () => {
          return 'canvasId_' + new Date().getTime()
        }
      },
      isGroup: {
        type: Boolean,
        default: false
      },
      isEdite: {
        type: Boolean,
        default: true
      }, // 如果不可以编辑 所有的点位不可以移动
      // 背景图
      baseImgSrc: {
        type: String,
        default: ''
      },
      areas: {
        type: Array,
        default: () => []
      },
      zoom: {
        type: Number,
        default: 0
      }, // 双向的
      canKeyMove: {
        type: Boolean,
        default: true
      }, // 是否可以键盘移动 小方块的位置
      isSplit: {
        // 是否是 手动画线状态  默认是
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        downKey: '',
        groupPosion: { x: 0, y: 0 }, // 组合初始化位置
        canvasInstance: undefined, // 画布实例
        baseImgInstance: undefined, // 图片实例为了生成缩略图  之后取消
        downPoint: null, // 按下鼠标时的坐标
        upPoint: null, // 松开鼠标时的坐标
        //整体移动位置
        lastPosX: 0, //
        lastPosY: 0, //
        timeId: '',
        activeObject: null //是否选中某个对象
      }
    },
    watch: {
      zoom(val) {
        val && this.canvasInstance?.setZoom(val / 100)
      },
      baseImgSrc(val) {
        this.createBaseImage(val)
      },
      areas() {
        this.initRect()
      }
    },
    async mounted() {
      this.initCanvas()
      this.resizeObserver = new ResizeObserver(() => {
        this.timeId && clearTimeout(this.timeId)
        this.timeId = setTimeout(() => {
          this.resize()
        }, 100)
      })
      // 监听元素
      this.resizeObserver.observe(this.$refs.canvasRef)
      document.addEventListener('keydown', this.keyDown)
      document.addEventListener('keyup', this.keyUp)
    },
    beforeDestroy() {
      this.resizeObserver.unobserve(this.$refs.canvasRef)
      document.removeEventListener('keydown', this.keyDown)
      document.removeEventListener('keyup', this.keyUp)
    },

    methods: {
      getSize() {
        let height = this.$refs.canvasRef?.offsetHeight
        let width = this.$refs.canvasRef?.offsetWidth
        return [height, width]
      },
      keyUp() {
        this.downKey = ''
      },
      keyDown(e) {
        this.downKey = e.keyCode
        let activeObject = this.activeObject
        if (!activeObject || !this.canKeyMove) return
        e.preventDefault()
        let Instance = activeObject.Instance

        let text = activeObject.text
        let { top, left } = Instance

        switch (e.keyCode) {
          case 37:
            left -= 1
            break
          case 38:
            top -= 1

            break
          case 39:
            left += 1
            break
          case 40:
            top += 1
            break
          default:
            return
        }
        Instance.set({ top, left })
        activeObject.x = left
        activeObject.y = top
        if (text) {
          text.set({ top: top - 20, left: left + 2 })
        }
        clearTimeout(this.timeId)
        this.timeId = setTimeout(() => {
          this.clearAllObject()
          activeObject.isSelect = true
          this.$emit('resetAreas', [...this.areas])
        }, 1000)
        this.canvasInstance.renderAll()
      },
      initCanvas() {
        const [height, width] = this.getSize()
        const canvas = (this.canvasInstance = new fabric.Canvas(this.canvasId, {
          width,
          height,
          cacheKey: '画布',
          isDrawingMode: false,
          backgroundColor: '#EAEDEE',
          selectionColor: 'transparent',
          selectionBorderColor: 'red',
          preserveObjectStacking: true,
          selection: this.isEdite ? this.isSplit : false // 取消组选择，多选
          // skipTargetFind: true // 禁止选中
        }))

        if (this.zoom > 0) {
          canvas.setZoom(this.zoom / 100)
        }

        canvas.on('object:modified', e => {
          let { top, left, aCoords } = e.target
          let { tl, tr, bl } = aCoords
          let treeItem = e.target.treeItem

          if (!treeItem) {
            // 表示是一个组在移动
            let position = {
              x: Math.round(left),
              y: Math.round(top),
              offSetx: Math.round(left - this.groupPosion.x),
              offSety: Math.round(top - this.groupPosion.y)
            }
            this.$emit('groupMove', position)
            return
          }
          this.areas.forEach(i => {
            i.isSelect = false
          })
          treeItem.y = Math.round(top)
          treeItem.x = Math.round(left)
          // 注意顺序
          this.clearAllObject()

          treeItem.w = Math.round(Math.abs(tr.x - tl.x))
          treeItem.h = Math.round(Math.abs(bl.y - tl.y))
          this.$nextTick(() => {
            treeItem.isSelect = true
            this.$emit('resetAreas', [...this.areas])
          })
        })
        canvas.on('mouse:wheel', this.canvasMouseWheel)
        canvas.on('mouse:down', this.canvas_mousedown)
        canvas.on('mouse:up', this.canvas_mouseup)
        canvas.on('mouse:move', this.canvas_mousemove)
        // 多选的时候 取消多选
        canvas.on('selection:created', e => {
          if (e.selected && e.selected.length > 1) {
            canvas.discardActiveObject()
          }
        })
      },
      async createBaseImage(src) {
        if (!src) {
          this.clearBaseImage()
          return
        }
        // if (this.zoom < 0) {
        await this.init_viewportTransform(src)
        // }
        // 生成一个背景图
        this.canvasInstance.setBackgroundImage(
          src,
          this.canvasInstance.renderAll.bind(this.canvasInstance),
          { crossOrigin: 'anonymous' }
        )
        new fabric.Image.fromURL(
          src,
          img => {
            this.baseImgInstance = img
          },
          { crossOrigin: 'anonymous' }
        )
      },
      // 清除背景图
      clearBaseImage() {
        if (this.canvasInstance?.backgroundImage) {
          this.canvasInstance.backgroundImage = null
          this.canvasInstance.renderAll()
        }
      },

      clearAllObject() {
        this.canvasInstance.getObjects().forEach(i => {
          this.canvasInstance.remove(i)
        })
      },
      initRect() {
        this.clearAllObject()
        if (!this.areas.length) return
        let isEdite = this.isEdite

        // 如果需要一个组

        let areas_list = []
        this.areas.forEach((i, index) => {
          let { drawType } = i
          let rect = null
          if (drawType === 'line') {
            let { x1, y1, x2, y2 } = i
            rect = this.addLIne([x1, y1, x2, y2])
          }
          if (drawType === 'rect') {
            let { y, x, w, h, isSelect, editeable } = i

            // 如果 内部 有属性  优先取 内部的属性
            if (typeof editeable != 'undefined') {
              isEdite = editeable
            }
            rect = this.addRect({
              cacheKey: index,
              top: y,
              left: x,
              width: w,
              height: h,
              isSelect,
              isEdite
            })
          }
          if (!rect) return
          rect.treeItem = i
          i.Instance = rect

          if (this.isGroup) {
            areas_list.push(rect)
          } else {
            this.canvasInstance.add(rect)
          }
        })
        if (this.isGroup) {
          this.creatGroup(areas_list)
        }
      },
      creatGroup(areas_list) {
        let group = new fabric.Group(areas_list, {
          stroke: 'black',
          fill: 'transparent',
          cornerSize: 0,
          transparentCorners: false,
          borderColor: 'red' // 控制对象边界的颜色（当对象处于活动状态时）
        })
        group.setControlsVisibility({
          mtr: false // 旋转 显示
        })
        this.canvasInstance.add(group)
        this.groupPosion = { x: group.left, y: group.top }
        return group
      },
      // 平移视口开始
      canvas_mousedown(opt) {
        let evt = opt.e
        if (
          evt.ctrlKey ||
          evt.altKey ||
          evt.metaKey ||
          evt.shiftKey ||
          this.downKey == 32
        ) {
          this.canvasInstance.hoverCursor = 'move'

          this.canvasInstance.set('hoverCursor', 'move')
          // ctrl + 鼠标按下
          this.canvasInstance.isDragging = true

          this.canvasInstance.draggingtCursor = 'move'
          this.canvasInstance.selection = false
        }
        this.canvasInstance.lastPosX = evt.clientX
        this.canvasInstance.lastPosY = evt.clientY
        this.downPoint = opt.absolutePointer
      },
      // 平移动视口中
      canvas_mousemove(opt) {
        if (!this.canvasInstance.isDragging) return
        let e = opt.e
        let vpt = this.canvasInstance.viewportTransform
        vpt[4] += e.clientX - this.canvasInstance.lastPosX
        vpt[5] += e.clientY - this.canvasInstance.lastPosY
        this.canvasInstance.lastPosX = e.clientX
        this.canvasInstance.lastPosY = e.clientY
        this.canvasInstance.renderAll()
      },
      // 平移视口结束和画图
      canvas_mouseup(opt) {
        if (this.canvasInstance.isDragging) {
          this.canvasInstance.setViewportTransform(
            this.canvasInstance.viewportTransform
          )
          this.canvasInstance.isDragging = false
          this.canvasInstance.selection = true
          // this.canvasInstance.defaultCursor = 'default'
        } else {
          if (!this.isSplit) return
          // if (this.activeObject || !this.isSplit) return
          this.upPoint = opt.absolutePointer
          this.createOption()
        }
      },
      addRect({
        top,
        left,
        width,
        height,
        cacheKey,
        isSelect,
        isEdite = true
      }) {
        let options = {
          top,
          left,
          width,
          height,
          cacheKey: cacheKey || new Date().getTime(),
          fill: 'transparent',
          hoverCursor: 'pointer', //pointer  default
          stroke: 'black',
          lockRotation: true,
          cornerStyle: 'rect', // 指定控件的样式，“rect”或“circle”
          cornerSize: 4, // 对象控制角的大小（以像素为单位）
          borderColor: 'red', // 控制对象边界的颜色（当对象处于活动状态时）
          cornerColor: 'red', // 控制对象角点的颜色（当它处于活动状态时）
          transparentCorners: false,
          selectable: isEdite
          // hasControls: false
        }
        let rect = new fabric.Rect(options)
        rect.setControlsVisibility({
          mtr: false // 旋转 显示
        })
        rect.on({
          selected: e => {
            let { top, left, width, height } = e.target
            this.activeObject = e.target.treeItem
            let { title, showTitle } = e.target.treeItem
            this.activeObject.isSelect = true
            this.creatImage({
              top,
              left,
              width,
              height,
              area: e.target.treeItem
            })
            // 如果有字体显示
            if (showTitle) {
              this.activeObject.text = this.addText({
                top: top - 20,
                left: left + 2,
                text: title
              })
            }
          },
          deselected: () => {
            if (this.activeObject) {
              this.activeObject.isSelect = false
            }
            if (this.activeObject?.text) {
              this.canvasInstance.remove(this.activeObject.text)
              this.activeObject.text = null
            }
            this.activeObject = null
          }
        })
        // this.canvasInstance.add(rect)
        if (isSelect) {
          this.$nextTick(() => {
            this.canvasInstance.setActiveObject(rect)
          })
        }
        return rect
      },
      addText({ top, left, text }) {
        let textInstance = new fabric.Text(text, {
          left,
          top,
          fontSize: 20,
          fill: 'black'
        })
        this.canvasInstance.add(textInstance)
        return textInstance
      },
      addLIne([x1, y1, x2, y2]) {
        let line = new fabric.Line([x1, y1, x2, y2], {
          fill: 'red', //填充颜色
          stroke: 'red', //笔触颜色
          hasControls: false,
          transparentCorners: false,
          selectable: false,
          strokeWidth: 2 //笔触宽度
        })
        return line
      },
      createOption() {
        let downPoint = this.downPoint
        let upPoint = this.upPoint
        if (JSON.stringify(downPoint) === JSON.stringify(upPoint)) {
          return
        }
        // 创建矩形
        let y = Math.round(Math.min(downPoint.y, upPoint.y))
        let x = Math.round(Math.min(downPoint.x, upPoint.x))
        let w = Math.round(Math.abs(downPoint.x - upPoint.x))
        let h = Math.round(Math.abs(downPoint.y - upPoint.y))
        if (w > 15 && h > 15) {
          let old = this.areas.map(i => {
            i.isSelect = false
            return i
          })
          old.push({
            drawType: 'rect',
            y,
            x,
            w,
            h,
            isSelect: true
          })
          this.$emit('resetAreas', old)
        }
        // 创建完矩形，清空 downPoint 和 upPoint。当然，你也可以不做这步。
        this.downPoint = null
        this.upPoint = null
      },
      // 根据位置生成小图
      creatImage(options = { top: 0, left: 0, widht: 0, height: 0, area: {} }) {
        if (!this.canvasInstance) return
        let { top, left, width, height, area } = options
        let option = {
          top: Math.round(top),
          left: Math.round(left),
          width: Math.round(width),
          height: Math.round(height)
        }

        if (!this.baseImgInstance) {
          setTimeout(() => {
            this.creatImage(options)
          }, 400)
          return
        }
        clearTimeout(this.timeId)
        this.timeId = setTimeout(() => {
          this.$emit('getFramesImage', {
            option,
            area,
            canvas: this.baseImgInstance
          })
        }, 400)
      },
      init_viewportTransform(url) {
        const [height, width] = this.getSize()
        return new Promise((resolve, reject) => {
          let img = new Image()
          img.setAttribute('crossOrigin', 'anonymous')
          img.onload = () => {
            let image_width = img.width
            let image_height = img.height
            let w_z = (width / image_width).toFixed(2)
            let h_z = (height / image_height).toFixed(2)

            let zoom = 100
            if (w_z > 1 && h_z > 1) {
              zoom = 100
            } else {
              zoom = parseInt(Math.min(w_z * 100, h_z * 100))
            }

            let x = 0
            let y = 0
            if (width > (image_width * zoom) / 100) {
              x = (width - (image_width * zoom) / 100) / 2
            }
            if (height > (image_height * zoom) / 100) {
              y = (height - (image_height * zoom) / 100) / 2
            }
            this.$emit('update:zoom', zoom)
            this.$nextTick(() => {
              this.canvasInstance.viewportTransform[4] = x
              this.canvasInstance.viewportTransform[5] = y
            })
            resolve({ zoom, x, y })
          }

          img.src = url
          // 图片加载失败的错误处理
          img.onerror = () => {
            console.log('图片展示失败')
            reject({ zoom: 100, x: 0, y: 0 })
          }
        })
      },
      // 滚轮，向上滚一下是 -100，向下滚一下是 100
      canvasMouseWheel(opt) {
        const delta = opt.e.deltaY
        let scale = this.zoom
        if (delta < 0) {
          //放大
          scale += 1
        } else {
          //缩小
          scale -= 1
        }
        if (scale > 200) scale = 200
        if (scale < 1) scale = 1
        this.canvasInstance.zoomToPoint(
          { x: opt.e.offsetX, y: opt.e.offsetY },
          scale / 100
        )
        this.$emit('update:zoom', scale)
        opt.e.preventDefault()
        opt.e.stopPropagation()
      },
      resize() {
        const [height, width] = this.getSize()
        this.canvasInstance.setWidth(width)
        this.canvasInstance.setHeight(height)
        if (!this.baseImgSrc) return
        this.init_viewportTransform(this.baseImgSrc)
      }
    }
  }
</script>

<style lang="less" scoped>
  .canvas_contents {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>
